import Vue from "vue";
import VueRouter from "vue-router";
import { routes } from "@/router/routes";
import store from "@/store/index";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// ページ公開設定とログイン状態をチェックする
router.beforeEach((to, from, next) => {
  if (
    to.matched.some(record => !record.meta.isPublic) &&
    !store.state.authInfo.access_token
  ) {
    next({ path: "/login" });
  } else {
    next();
  }
});

export default router;
